const prefix = '@retailMedia/industry/minCosts'

export const MIN_COSTS_GET = `${prefix}/get`

export const types = {
  getMinCosts: MIN_COSTS_GET
}
